(function($) {

	$(document).ready(function() {
    $('.movex-equipments #post-tax-filters input[type="checkbox"]').on('change', movexEquipmentHandleFiltersQueryParams);

    $('.movex-equipments #post-tax-filters-challenge input[type="checkbox"]').on("change", movexEquipmentHandleFiltersQueryParams);
    $('.movex-equipments #post-tax-filters-industries input[type="checkbox"]').on("change", movexEquipmentHandleFiltersQueryParams);
    $('.movex-equipments #post-tax-filters-equipment input[type="checkbox"]').on("change", movexEquipmentHandleFiltersQueryParams);


    $('body').on('click', '.movex-equipments #filters-pagination a', movexEquipmentHandleFiltersQueryParams);
    $('.movex-equipments #post-filters-form').on('submit', movexEquipmentHandleFiltersQueryParams);

  })
  
  
  /**
   * Function called when a filter checkbox changes, a pagination change is requested or when the search input has been submitted.
   * Used to dynamically add the filter params to the URL. We add the filters to the URL to make sure that when a user clicks "back" in his browser, he will keep the filters he was on.
   * When all the filters are in the URL, it triggers the AJAX call to refresh the content based on the URL parameters.
   */
  function movexEquipmentHandleFiltersQueryParams(e){
    // If the browser supports pushState
    if(history.pushState){
      let search_params = new URLSearchParams(window.location.search);
      let all_tax_names = [];
      
      //Creates an array of all the taxonomies that can be filtered by parsing the checkboxes
      $('#post-tax-filters input[type="checkbox"]').each(function() {
        if(all_tax_names.indexOf($(this).data('taxonomy')) == -1){
          all_tax_names.push($(this).data('taxonomy'));
        }
      });

      //Append all selected term IDs for all the taxonomies to the URL
      $.each(all_tax_names, (index, taxonomy_name) => {
        let selected_terms = [];
        
        $('#post-tax-filters input[data-taxonomy="'+taxonomy_name+'"]:checked').each(function() {
          selected_terms.push($(this).val());
        });

        if(selected_terms.length > 0){
          search_params.set(taxonomy_name + '_filters', selected_terms.join());
        }
        else{
          search_params.delete(taxonomy_name + '_filters');
        }
      });

      if(e.target.id == 'filter_post_type'){
        if(!$(this).val()){
          search_params.delete('filter_post_type');
        }
        else{
          search_params.set('filter_post_type', $(this).val());
        }
      }

     let industryFilters = [];
     $('#post-tax-filters-industries input[type="checkbox"]:checked').each(
       function () {
         industryFilters.push($(this).val());
       }
     );
     let challengeFilters = [];
     $('#post-tax-filters-challenge input[type="checkbox"]:checked').each(
       function () {
         challengeFilters.push($(this).val());
       }
     );
     let equipmentFilters = [];
     $('#post-tax-filters-equipment input[type="checkbox"]:checked').each(
       function () {
         equipmentFilters.push($(this).val());
       }
     );

     if (industryFilters.length) {
       search_params.set("filter_industry", industryFilters.join());
     } else {
       search_params.delete("filter_industry");
     }
      if (challengeFilters.length) {
        search_params.set("filter_challenge", challengeFilters.join());
      } else {
        search_params.delete("filter_challenge");
      }
      if (equipmentFilters.length) {
        search_params.set("filter_equipment", equipmentFilters.join());
      } else {
        search_params.delete("filter_equipment");
      }
      

      //If the clicked object is a pagination link
      if($(this).hasClass('page-numbers')){
        e.preventDefault();
        let pagination_link = $(this).attr('href');
        let page_number_matches = pagination_link.match(/\/page\/(\d*)/);
        //If the regex found matches for a page number
        if(page_number_matches){
          search_params.set('filter_page', page_number_matches[1]);
        }
        else{
          //If there's no page number found, remove the page param
          search_params.delete('filter_page');
        }
      }
      else if($(this).data('taxonomy')){
        //If it's a filter checkbox has changed, reset the pagination so we go back to the first page
        search_params.delete('filter_page');
      }
      else if($(this).is('form')){
        //If the search input has been submitted, set the search URL param
        if($('#filters-text-search').val()){
          search_params.set('search', $('#filters-text-search').val());
        }
        else{
          search_params.delete('search');
        }
        //Reset the pagination so we go back to the first page
        search_params.delete('filter_page');
      }

      // The new url string
      let new_url = window.location.protocol + "//" + window.location.host + window.location.pathname;
      if(search_params.toString()){
        new_url += '?' + search_params.toString();
      }
      window.history.pushState({path: new_url}, '', new_url);

      //Trigger the content refresh
      
      movexEquipmentRefreshFilteredContent(search_params.toString());
    }

    return false;
  }

  /**
   * Function making an AJAX request in order to refresh the content based on the filters.
   * @todo: Slow the query and add a loading screen.
   * @param {string} search_params: Query string containing all the filters
   */
  function movexEquipmentRefreshFilteredContent(search_params){
    let $results_container = $('#filtered-content');
    
    if($results_container.length > 0){
      let urlParams = new URLSearchParams(search_params);
      let post_types = [];
      let all_post_types = [];
      let challenge = [];
      let equipment = [];
      let industry = [];
      if(urlParams.get('filter_post_type')){
        post_types.push(urlParams.get('filter_post_type'));
        $('input[name="filters-all-post-type[]"]').each(function() {
          all_post_types.push($(this).val());
        });
      }
      else{
        $('input[name="filters-all-post-type[]"]').each(function() {
          post_types.push($(this).val());
          all_post_types.push($(this).val());
        });
      }
      if(urlParams.get('filter_challenge')){
        challenge.push(urlParams.get('filter_challenge'));
      }
      if(urlParams.get('filter_industry')){
        industry.push(urlParams.get('filter_industry'));
      }
      if (urlParams.get("filter_equipment")) {
        equipment.push(urlParams.get("filter_equipment"));
      }

      $.ajax({
        url: ajaxurl + "?" + search_params,
        type: "GET",
        data: {
          action: "movex_filtered_equipment",
          post_type: post_types,
          all_post_types: all_post_types,
          challenge: challenge,
          industry: industry,
          equipment: equipment,
        },
        success: function (result) {
          $results_container.empty();
          $results_container.append(result);

          var new_position = $("#filters-anchor").offset();
          $("html, body").stop().animate({ scrollTop: new_position.top }, 500);
        },
      });
    }
  }

  function movexEquipmentTagsCheckBox(){
    $(this).prev().click();
  }

  var debounce = function (func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
  };
})(jQuery);